module.exports = __webpack_public_path__ + "static/media/Icn-otf.1c87c015.svg";